import { defineComponent as _defineComponent } from 'vue'
import { useSurfacePostsDragAndDropStore } from '@@/pinia/surface_posts_drag_and_drop'
import { GroupByTypes } from '@padlet/arvo'
import sectionSorter from 'bits/section_sorter'
import { storeToRefs } from 'pinia'
import { useSurfaceStore } from 'pinia/surface'
import { useSurfacePostsStore } from 'pinia/surface_posts'
import { useSurfaceSectionsStore } from 'pinia/surface_sections'
import { useSurfaceWishArrangementStore } from 'pinia/surface_wish_arrangement'
import { useWindowSizeStore } from 'pinia/window_size'
import { computePostIndexFromPost } from 'surface/sorter'
import { computed } from 'vue'
import SurfacePostGroupHeaderSection from 'vuecomponents/SurfacePostGroupHeaderSection.vue'
import SurfacePostsDraggablePad from 'vuecomponents/SurfacePostsDraggablePad.vue'
import SurfacePost from 'vuecomponents/surface_post.vue'
import { useDragSortableInGroups } from 'vuecomposables/surface_posts_drag_sortable_in_groups'
import { useScrollToNewestPost } from 'vuecomposables/surface_scroll_to_newest_post'
import { useSurfaceSectionsDragSortable } from 'vuecomposables/surface_sections_drag_sortable'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostsStream',
  props: {
  reactionIdsByPostId: { type: Object, default: () => ({}) },
  commentIdsByPostId: { type: Object, default: () => ({}) },
},
  setup(__props) {



const surfacePostsStore = useSurfacePostsStore()
const surfacePostsDragAndDropStore = useSurfacePostsDragAndDropStore()
const surfaceSectionsStore = useSurfaceSectionsStore()

const { dir, backgroundLuminance, isPostSizeStandard, isPostSizeWide } = storeToRefs(useSurfaceStore())
const { isAPostDragging, groupIdUnderPostBeingDragged } = storeToRefs(surfacePostsDragAndDropStore)
const { allSortedPostsByGroup } = storeToRefs(surfacePostsStore)
const { isASectionDragging } = storeToRefs(surfaceSectionsStore)
const { sortedGroups, wishGroupBy } = storeToRefs(useSurfaceWishArrangementStore())
const windowSizeStore = useWindowSizeStore()
const { isSmallerThanTabletPortrait } = storeToRefs(windowSizeStore)

const { shouldDisplayPost } = surfacePostsStore
const { canShowDraggingOverlayOnGroup } = surfacePostsDragAndDropStore

const overlayHeight = computed(() => {
  const hoveredSectionQuery = `#section-${groupIdUnderPostBeingDragged.value}`
  const hoveredSectionElementHeight = document.querySelector(hoveredSectionQuery)?.getBoundingClientRect().height
  // add extra height to the overlay so it extends beyond posts and section header
  return hoveredSectionElementHeight ? hoveredSectionElementHeight + 32 : 0
})

const overlayWidth = computed(() => {
  const postElementWidth = document.querySelector('.wish-v2')?.getBoundingClientRect().width
  // add extra width to the overlay so it extends beyond posts
  return postElementWidth ? postElementWidth + 16 : 0
})

useSurfaceSectionsDragSortable({
  onDragStart: () => {
    isASectionDragging.value = true
  },
  onDragEnd: ({ groupId }) => {
    isASectionDragging.value = false
    if (groupId) {
      const sectionElement = document.querySelector(`#section-${groupId}`) as HTMLElement | undefined
      if (!sectionElement) return
      const sortResult = sectionSorter.getNewIndex(sectionElement)
      if (!sortResult) return
      surfaceSectionsStore.sortSection(sortResult)
    }
  },
})
useDragSortableInGroups({
  onDragStart: ({ groupId }) => {
    isAPostDragging.value = true
    groupIdUnderPostBeingDragged.value = groupId
  },
  onDragEnd: ({ postCid, postId, groupId }) => {
    isAPostDragging.value = false
    if (postCid && postId) {
      const sectionId = typeof groupId === 'number' && wishGroupBy.value === GroupByTypes.Section ? groupId : undefined
      const prevWish = document
        .querySelector(`#wish-${postId}`)
        ?.closest('.wish-wrapper')
        ?.previousElementSibling?.querySelector('.wish') as HTMLElement | undefined
      const nextWish = document
        .querySelector(`#wish-${postId}`)
        ?.closest('.wish-wrapper')
        ?.nextElementSibling?.querySelector('.wish') as HTMLElement | undefined
      const { sortIndex, gapSize } = computePostIndexFromPost(`#wish-${postId}`, {
        sectionId,
        prevId: prevWish?.id,
        nextId: nextWish?.id,
      })
      surfacePostsStore.sortPost({
        postCid,
        sortIndex: sortIndex ?? undefined,
        sectionId,
        gapSize,
      })
    }
    groupIdUnderPostBeingDragged.value = undefined
  },
  format: 'stream',
})

useScrollToNewestPost()

return { __sfc: true,surfacePostsStore, surfacePostsDragAndDropStore, surfaceSectionsStore, dir, backgroundLuminance, isPostSizeStandard, isPostSizeWide, isAPostDragging, groupIdUnderPostBeingDragged, allSortedPostsByGroup, isASectionDragging, sortedGroups, wishGroupBy, windowSizeStore, isSmallerThanTabletPortrait, shouldDisplayPost, canShowDraggingOverlayOnGroup, overlayHeight, overlayWidth, GroupByTypes, SurfacePostGroupHeaderSection, SurfacePostsDraggablePad, SurfacePost }
}

})